/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

/**
 * @description It converts a string separated by underscores to a human readable string
 * @param text
 * @param separator
 * @param {string} string String to humanize
 * @returns {string}
 */
const camelize = (text, separator = "_") => {
  if (!text) {
    return "";
  }
  return text
    .split(separator)
    .map((w) => w.replace(/./, (m) => m.toUpperCase()))
    .join(" ");
};
export default camelize;
